import { SVGProps, memo } from 'react'

import { CompanySelector, Spinner } from '@factorialco/f0-react/dist/experimental'

type DemoContextProps = {
  companyName: string
  loading?: boolean
  logoUrl?: string
}

const InContextDemo = memo(
  ({
    companyName,
    logoUrl,
    loading = false,
    ...props
  }: DemoContextProps & SVGProps<SVGSVGElement>) => {
    return (
      <div className="relative">
        <div className="absolute" style={{ top: '24px', left: '10px' }}>
          {!loading && companyName && (
            <CompanySelector
              selected="1"
              companies={[{ id: '1', name: companyName, logo: logoUrl }]}
              onChange={() => {}}
            />
          )}
          {loading && <Spinner className="px-2" />}
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          fill="none"
          width={360}
          height={250}
          {...props}
        >
          <g clipPath="url(#a)">
            <rect width={360} height={250} fill="#051F51" fillOpacity={0.04} rx={16} />
            <circle cx={28} cy={136} r={10} fill="#051F51" fillOpacity={0.04} />
            <rect width={86} height={10} x={44} y={131} fill="#051F51" fillOpacity={0.04} rx={4} />
            <circle cx={28} cy={172} r={10} fill="#051F51" fillOpacity={0.04} />
            <rect width={123} height={10} x={44} y={167} fill="#051F51" fillOpacity={0.04} rx={4} />
            <circle cx={28} cy={208} r={10} fill="#051F51" fillOpacity={0.04} />
            <rect width={67} height={10} x={44} y={203} fill="#051F51" fillOpacity={0.04} rx={4} />
            <path
              fill="#fff"
              fillOpacity={0.6}
              d="M12 86c0-5.523 4.477-10 10-10h196c5.523 0 10 4.477 10 10v12c0 5.523-4.477 10-10 10H22c-5.523 0-10-4.477-10-10V86Z"
            />
            <path
              stroke="#052657"
              strokeOpacity={0.06}
              d="M22 76.5h196a9.5 9.5 0 0 1 9.5 9.5v12a9.5 9.5 0 0 1-9.5 9.5H22a9.5 9.5 0 0 1-9.5-9.5V86a9.5 9.5 0 0 1 9.5-9.5Z"
            />
            <circle cx={28} cy={92} r={10} fill="#051F51" fillOpacity={0.04} />
            <rect width={86} height={10} x={42} y={87} fill="#051F51" fillOpacity={0.04} rx={4} />
            <g clipPath="url(#b)">
              <path fill="url(#c)" d="M18 24h24v24H18z" />
            </g>
          </g>
          <defs>
            <clipPath id="a">
              <rect width={360} height={250} fill="#fff" rx={16} />
            </clipPath>
            <clipPath id="b">
              <rect width={24} height={24} x={18} y={24} fill="#fff" rx={8} />
            </clipPath>
            <pattern id="c" width={1} height={1} patternContentUnits="objectBoundingBox">
              <use xlinkHref="#e" transform="matrix(.00091 0 0 .00091 -.002 -.002)" />
            </pattern>
            <filter
              id="d"
              width={160}
              height={286}
              x={220}
              y={-14}
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy={2} />
              <feGaussianBlur stdDeviation={10} />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix values="0 0 0 0 0.0509804 0 0 0 0 0.0862745 0 0 0 0 0.145098 0 0 0 0.04 0" />
              <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3109_6059" />
              <feBlend in="SourceGraphic" in2="effect1_dropShadow_3109_6059" result="shape" />
            </filter>
          </defs>
        </svg>
      </div>
    )
  }
)

InContextDemo.displayName = 'InContextDemo'
export { InContextDemo }
